export function minLengthValidation(inputData, minLength) {
  // const { value } = inputData;

  // removeClassErrorSuccess(inputData);

  if (inputData.length >= minLength) {
    // inputData.classList.add("success");
    return true;
  } else {
    // inputData.classList.add("error");
    return false;
  }
}
export function passValidation(inputData) {
  // Comprobar si la contraseña contiene al menos una letra mayúscula
  const tieneMayuscula = /[A-Z]/.test(inputData);
  
  // Comprobar si la contraseña contiene al menos una letra minúscula
  const tieneMinuscula = /[a-z]/.test(inputData);
  
  // Comprobar si la contraseña contiene al menos un número
  const tieneNumero = /\d/.test(inputData);

  // Si todas las condiciones se cumplen, devolver true, de lo contrario, devolver false
  return tieneMayuscula && tieneMinuscula && tieneNumero;
}

//Exporto las funciones para poder utilizarlas en otros archivos
export function emailValidation(inputData) {
  // eslint-disable-next-line no-useless-escape
  const emailValid =
    /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  // const { value } = inputData;

  // removeClassErrorSuccess(inputData);

  const resultValidation = emailValid.test(inputData);
  // console.log(inputData)
  // console.log(resultValidation)
  if (resultValidation) {
    // inputData.classList.add("success");
    return true;
  } else {
    // inputData.classList.add("error");
    return false;
  }
}



function removeClassErrorSuccess(inputData) {
  inputData.classList.remove("success");
  inputData.classList.remove("error");
}
